import React, { Component } from 'react'
import { Button, Form, Input, Modal } from 'antd'
import _ from 'lodash'

import './TemplateExportModal.scss'

const FormItem = Form.Item

export default class TemplateExportModal extends Component {
    constructor(props) {
        super(props)

        this.state = {
            modalVisible: false,
            templateName: ''
        }

        this.handleClick = this.handleClick.bind(this)
        this.handleCancel = this.handleCancel.bind(this)
        this.handleConfirm = this.handleConfirm.bind(this)
        this.handleTemplateNameChange = this.handleTemplateNameChange.bind(this)
    }

    handleClick() {
        this.setState({ modalVisible: true })
    }

    handleCancel() {
        this.setState({ modalVisible: false })
    }

    handleConfirm() {
        const { onConfirm } = this.props
        const { templateName } = this.state

        onConfirm(templateName)

        this.setState({ modalVisible: false })
    }

    handleTemplateNameChange(e) {
        this.setState({ templateName: e.target.value })
    }

    render() {
        const { modalVisible, templateName } = this.state

        return (
            <div className="TemplateExportModal-wrapper">
				<Button type="primary" onClick={this.handleClick}>Save as Template</Button>
				<Modal
                    width="60%"
                    wrapClassName="TemplateExportModal"
                    footer={null}
					visible={modalVisible}
					onCancel={this.handleCancel}
				>
                    <p className="info">Enter the new template name.</p>
                    <div className="content">
                    	<Form>
                    		<FormItem
                    			label="New Template Name"
						        labelCol={{ span: 11 }}
						    	wrapperCol={{ span: 9 }}
                    		>
								<Input 
									value={templateName}
									onChange={this.handleTemplateNameChange}
								/>
                    		</FormItem>
                    	</Form>
                    </div>
                    <div className="footer">
						<Button type="primary" size="large" onClick={this.handleConfirm} disabled={templateName.length === 0}>Save</Button>
					</div>
				</Modal>
			</div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Commons/TemplateExportModal/TemplateExportModal.js